import * as angular from "angular";
import * as _ from "lodash";
import {IFilterService} from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class BatchAlertsService {

  constructor(private bringozToastService: BringozToastService, private $filter: IFilterService) {
  }

  createSchemaSuccess() {
    let message = {
      body: 'SCHEMA_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createSchemaError() {
    let message = {
      body: 'SCHEMA_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  editSchemaSuccess() {
    let message = {
      body: 'SCHEMA_EDIT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  editSchemaError() {
    let message = {
      body: 'SCHEMA_EDIT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteSchemaSuccess() {
    let message = {
      body: 'SCHEMA_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteSchemaError() {
    let message = {
      body: 'SCHEMA_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getEntityImportPreviewError() {
    let message = {
      body: 'GET_ENTITY_PREVIEW_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  entityMappingError(){
    let message = {
      body: 'ENTITY_MAPPING_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  importEntitiesError(error?) {
    let message = {
      body: 'IMPORT_ENTITIES_ERROR',
      details: 'SOMETHING_WENT_WRONG',
      message: _.get(error, 'more_info')
    };
    return this.bringozToastService.error(message)
  }

  importEntitiesSuccess() {
    let message = {
      body: 'IMPORT_ENTITIES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  batchRecoverySuccess() {
    const message = {
      body: 'BATCH_RECOVERY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  batchRecoveryError(error?) {
    const message = {
      body: 'BATCH_RECOVERY_ERROR',
      message: _.get(error, 'more_info'),
      details: _.get(error, 'more_info') ? undefined : 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.batch')
  .service('batchAlertsService', BatchAlertsService);
